import * as React from "react"
import { Button } from "react-bootstrap"
import { Search } from "react-bootstrap-icons"
import { useTranslation } from "react-i18next"

export const SearchBar = (props: Record<string, any>) => {
    let input: any
    const searchClick = () => {
        props.onSearch(input.value)
    }
    return (
        <div className={`input-group ${props?.float ? props?.float : "float-start"}`}>
            <input
                className="form-control"
                ref={(n) => (input = n)}
                type="text"
                onKeyUp={searchClick}
                placeholder={"Search"}
            />
            <div className="input-group-btn px-2" onClick={searchClick}>
                <Search color="#2D3748" size={10} className="mx-2 my-2 arrow-icon" />
            </div>
        </div>
    )
}

export const CustomSearchBar = (props: Record<string, any>) => {
    const { t } = useTranslation()
    let input: any
    const searchClick = () => {
        props?.onSearchData(input.value)
    }
    const handleKeyDown = (e: any) => {
        if (e.key === "Enter") {
            props?.onSearchData(input.value)
        }
    }
    return (
        <div className="w-100 search-main">
            <Button id="btn-primary" className="btn btn-primary" type="submit" onClick={searchClick}>
                {t("Search")}
            </Button>
            <div className="float-end input-group mx-2">
                <input
                    className="form-control"
                    ref={(n) => (input = n)}
                    type="text"
                    placeholder={"Search"}
                    onKeyDown={handleKeyDown}
                    defaultValue={props.inputVal}
                />
                <div className="input-group-btn px-2" onClick={searchClick}>
                    <Search color="#2D3748" size={10} className="mx-2 my-2 arrow-icon" />
                </div>
            </div>
        </div>
    )
}

export const SelectFilterColums = (props: Record<string, any>) => {
    let options = React.useMemo(() => {
        const options = new Set()

        props?.preFilteredRows?.forEach((row: Record<string, any>[]): void => {
            if (!!row[props?.id]) {
                if (props?.id === "email_verified_at") {
                    options.add("Verified")
                    options.add("Unverified")
                } else if (row[props?.id] && typeof row[props?.id] !== "object") options.add(row[props?.id])
                else if (typeof row[props?.id] === "object") {
                    if (typeof row[props?.id][props?.subId] === "object")
                        options.add(row[props?.id][props?.subId][props?.otherSubId])
                    else options.add(row[props?.id][props?.subId])
                }
            }
        })
        return [...options?.values()]
    }, [props?.id, props?.preFilteredRows])

    if (props?.table === "purchase_request") {
        let newoptions = []
        newoptions.push(
            "All",
            "Payment Pending",
            "Payment Completed",
            "Purchased",
            "Rejected",
            "Confirmation Request",
            "Collected",
            "Deleted"
        )
        options = newoptions
    }
    if (props.id === "active" && props.table === "suite") {
        let newoptions = []
        newoptions.push("Free", "Busy")
        options = newoptions
    }

    // Render a multi-select box
    return (
        <div id="filter-div">
            <select
                className="form-control select-column col-lg-3 col-md-6 col-sm-12 col-12 w-100 input-lg"
                size={1}
                onChange={(e) => {
                    props?.onFilterClick(e.target.value || undefined, props?.id, props?.subId || undefined)
                }}>
                <option value="">{props?.text}: All</option>
                {options?.map((option, i: number) => (
                    <option
                        key={i}
                        value={option as string}
                        selected={props.activeFilter === (option as string) ? true : false}>
                        {props?.text}: {capitalize(option as string)}
                    </option>
                ))}
            </select>
        </div>
    )
}

function capitalize(str: String): string {
    if ((!!str && typeof str === "string") || str instanceof String)
        return str[0]?.toUpperCase() + str?.slice(1)
    else return str
}
